import { Modal } from 'antd';
const { confirm } = Modal;

export function forceCleanupConformation(confirmCleanup, cloudAccountName = 'Not Available') {
  confirm({
    closable: true,
    width: 1000,
    maskClosable: true,
    title: (
      <p
        style={{
          margin: 0,
          fontSize: '1em',
        }}
      >
        <span>
          Force the Cleanup Operation on <b style={{ color: '#1890ff' }}>{cloudAccountName}</b>
        </span>
      </p>
    ),
    content: (
      <p
        style={{
          margin: 0,
          fontSize: '0.8em',
        }}
      >
        <span>
          This forced operation should only be executed if the automatic cleanup function fails to
          execute as expected due to an unforeseen issue.
          <br />
          Forcing the Cleanup Operation manually from here will ensure that all the AMIs, Snapshots,
          Volumes and Instances created during Cloudxray scan are deleted. This action is
          irreversible.
          <br />
          Afterwards, you will be able to run scan normally again.
        </span>
      </p>
    ),
    okType: 'danger',
    okText: 'Force Cleanup',
    cancelText: 'Cancel',
    cancelButtonProps: {
      onClick: () => {
        Modal.destroyAll();
      },
    },
    onCancel() {
      Modal.destroyAll();
    },
    centered: true,
    async onOk() {
      await confirmCleanup();
    },
  });
}
